/** @enum {PromoTargets} */
/** @typedef {String} PromoTargets */
export const PROMO_TARGETS = {
  TOTAL_WITHOUT_SHIPPING: "TOTAL_WITHOUT_SHIPPING",
  TOTAL: "TOTAL",
  SHIPPING: "SHIPPING",
  DEVICE: "DEVICE",
  MEMBERSHIP: "MEMBERSHIP",
  ADMIN_ACCESS: "ADMIN_ACCESS",
  MCS_MARKETPLACE_ACCESS: "MCS_MARKETPLACE_ACCESS"
};

/** @enum {PromoTypes} */
/** @typedef {String} PromoTypes */
export const PROMO_TYPES = {
  FLAT: "f",
  PERCENTAGE: "p",
  SUB_DELAY: "s"
};

class PromoCode {
  constructor(promoType, promoTarget, amount, promoCodeText, appliedMessage, hasLicenseKey) {
    /**
     * What type of promo code is this? Is it a flat discount, a percentage discount, etc.
     * @type {PromoTypes}
     */
    this.promoType = null;

    switch (promoType.toUpperCase()) {
      case "P":
        this.promoType = PROMO_TYPES.PERCENTAGE;
        break;
      case "S":
        this.promoType = PROMO_TYPES.SUB_DELAY;
        break;
      default:
        this.promoType = PROMO_TYPES.FLAT;
    }

    /**
     * Which aspect of the order does the promo code apply to (ex. device, membership, total, etc).
     * @type {PromoTargets}
     */
    this.promoTarget = promoTarget;

    /**
     * The amount of the promo code. This value is meaningless without considering the {@link promoType}.
     * @type {Number}
     */
    this.amount = amount;

    /**
     * The text of the promo code (ex. SHAPA2020).
     * @type {String}
     */
    this.promoCodeText = promoCodeText;

    /**
     * The message that will be displayed to the user when the promo code is successfully applied.
     * @type {String}
     */
    this.appliedMessage = appliedMessage;

    /**
     * If true, the promo code includes a license key for a prepaid membership.
     * @type {boolean}
     */
    this.hasLicenseKey = hasLicenseKey;
  }
}

export default PromoCode;